import { equals2v6cggk171b6e as equals } from '../../../../kotlin-kotlin-stdlib/kotlin/text/stringsCode.mjs';
import { Collection1k04j3hzsbod0 as Collection } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/Collections.mjs';
import {
  isInterface3d6p8outrmvmk as isInterface,
  isCharSequence1ju9jr1w86plq as isCharSequence,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import {
  isBlank1dvkhjjvox3p0 as isBlank,
  indexOf1xbs558u7wr52 as indexOf,
  trim11nh7r46at6sx as trim,
  contains2el4s70rdq4ld as contains,
  startsWith38d3sbg25w0lx as startsWith,
} from '../../../../kotlin-kotlin-stdlib/kotlin/text/Strings.mjs';
import {
  Companion_instance219cxyaprolfe as Companion_instance,
  HeaderValueWithParameters2awuza444hhll as HeaderValueWithParameters,
} from './HeaderValueWithParameters.mjs';
import {
  parseHeaderValuealpos28fgp6t as parseHeaderValue,
  HeaderValueParam1kbqez3tb3lqp as HeaderValueParam,
} from './HttpHeaderValueParser.mjs';
import {
  last1vo29oleiqj36 as last,
  plus20p0vtfmu0596 as plus,
} from '../../../../kotlin-kotlin-stdlib/kotlin/collections/_Collections.mjs';
import { _Char___init__impl__6a9atxrzocepzq3zgi as _Char___init__impl__6a9atx } from '../../../../kotlin-kotlin-stdlib/kotlin/Char.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import {
  toString1pkumu07cwy4m as toString,
  equals2au1ep9vhcato as equals_0,
  getStringHashCode26igk1bx568vk as getStringHashCode,
  hashCodeq5arwsb9dgti as hashCode,
  captureStack1fzi4aczwc4hg as captureStack,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { take9j4462mea726 as take } from '../../../../kotlin-kotlin-stdlib/kotlin/text/_Strings.mjs';
import { charSequenceLength3278n89t01tmv as charSequenceLength } from '../../../../kotlin-kotlin-stdlib/kotlin/js/charSequenceJs.mjs';
import { substring3saq8ornu0luv as substring } from '../../../../kotlin-kotlin-stdlib/kotlin/text/stringJs.mjs';
import {
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { emptyList1g2z5xcrvp2zy as emptyList } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/CollectionsKt.mjs';
import {
  Charsets_getInstancezrqwjk0yrlyw as Charsets_getInstance,
  forName2faodmskqnoz5 as forName,
  get_name2f11g4r0d5pxp as get_name,
} from '../../../../ktor-ktor-io/io/ktor/utils/io/charsets/Charset.js.mjs';
import {
  IllegalArgumentException2asla15b5jaob as IllegalArgumentException,
  Exceptiondt2hlxn7j7vw as Exception,
} from '../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { setOf45ia9pnfhe90 as setOf } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/Sets.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
var textSubTypes;
function hasParameter($this, name, value) {
  var tmp;
  switch ($this.parameters_1.get_size_woubt6_k$()) {
    case 0:
      tmp = false;
      break;
    case 1:
      // Inline function 'kotlin.let' call

      var it = $this.parameters_1.get_c1px32_k$(0);
      tmp = (equals(it.name_1, name, true) && equals(it.value_1, value, true));
      break;
    default:
      var tmp0 = $this.parameters_1;
      var tmp$ret$2;
      $l$block_0: {
        // Inline function 'kotlin.collections.any' call
        var tmp_0;
        if (isInterface(tmp0, Collection())) {
          tmp_0 = tmp0.isEmpty_y1axqb_k$();
        } else {
          tmp_0 = false;
        }
        if (tmp_0) {
          tmp$ret$2 = false;
          break $l$block_0;
        }
        var _iterator__ex2g4s = tmp0.iterator_jk1svi_k$();
        while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
          var element = _iterator__ex2g4s.next_20eer_k$();
          if (equals(element.name_1, name, true) && equals(element.value_1, value, true)) {
            tmp$ret$2 = true;
            break $l$block_0;
          }
        }
        tmp$ret$2 = false;
      }

      tmp = tmp$ret$2;
      break;
  }
  return tmp;
}
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {
      constructor() {
        Companion_instance_0 = this;
        this.Any_1 = ContentType().new_io_ktor_http_ContentType_8p6a24_k$('*', '*');
      }
      parse_pc1q8p_k$(value) {
        if (isBlank(value))
          return this.Any_1;
        // Inline function 'io.ktor.http.Companion.parse' call
        var headerValue = last(parseHeaderValue(value));
        var tmp0 = headerValue.value_1;
        var parameters = headerValue.params_1;
        var slash = indexOf(tmp0, _Char___init__impl__6a9atx(47));
        if (slash === -1) {
          // Inline function 'kotlin.text.trim' call
          if (toString(trim(isCharSequence(tmp0) ? tmp0 : THROW_CCE())) === '*')
            return Companion_getInstance().Any_1;
          throw BadContentTypeFormatException().new_io_ktor_http_BadContentTypeFormatException_pqz1qq_k$(value);
        }
        // Inline function 'kotlin.text.trim' call
        var this_0 = take(tmp0, slash);
        var type = toString(trim(isCharSequence(this_0) ? this_0 : THROW_CCE()));
        // Inline function 'kotlin.text.isEmpty' call
        if (charSequenceLength(type) === 0) {
          throw BadContentTypeFormatException().new_io_ktor_http_BadContentTypeFormatException_pqz1qq_k$(value);
        }
        // Inline function 'kotlin.text.trim' call
        var this_1 = substring(tmp0, slash + 1 | 0);
        var subtype = toString(trim(isCharSequence(this_1) ? this_1 : THROW_CCE()));
        if (contains(type, _Char___init__impl__6a9atx(32)) || contains(subtype, _Char___init__impl__6a9atx(32))) {
          throw BadContentTypeFormatException().new_io_ktor_http_BadContentTypeFormatException_pqz1qq_k$(value);
        }
        var tmp;
        // Inline function 'kotlin.text.isEmpty' call
        if (charSequenceLength(subtype) === 0) {
          tmp = true;
        } else {
          tmp = contains(subtype, _Char___init__impl__6a9atx(47));
        }
        if (tmp) {
          throw BadContentTypeFormatException().new_io_ktor_http_BadContentTypeFormatException_pqz1qq_k$(value);
        }
        return ContentType().new_io_ktor_http_ContentType_8p6a24_k$(type, subtype, parameters);
      }
    }
    initMetadataForCompanion($);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance_0;
function Companion_getInstance() {
  if (Companion_instance_0 === VOID) {
    Companion_instance;
    new (Companion())();
  }
  return Companion_instance_0;
}
var ApplicationClass;
function Application() {
  if (ApplicationClass === VOID) {
    class $ {
      constructor() {
        Application_instance = this;
        this.TYPE_1 = 'application';
        this.Any_1 = ContentType().new_io_ktor_http_ContentType_8p6a24_k$('application', '*');
        this.Atom_1 = ContentType().new_io_ktor_http_ContentType_8p6a24_k$('application', 'atom+xml');
        this.Cbor_1 = ContentType().new_io_ktor_http_ContentType_8p6a24_k$('application', 'cbor');
        this.Json_1 = ContentType().new_io_ktor_http_ContentType_8p6a24_k$('application', 'json');
        this.HalJson_1 = ContentType().new_io_ktor_http_ContentType_8p6a24_k$('application', 'hal+json');
        this.JavaScript_1 = ContentType().new_io_ktor_http_ContentType_8p6a24_k$('application', 'javascript');
        this.OctetStream_1 = ContentType().new_io_ktor_http_ContentType_8p6a24_k$('application', 'octet-stream');
        this.Rss_1 = ContentType().new_io_ktor_http_ContentType_8p6a24_k$('application', 'rss+xml');
        this.Soap_1 = ContentType().new_io_ktor_http_ContentType_8p6a24_k$('application', 'soap+xml');
        this.Xml_1 = ContentType().new_io_ktor_http_ContentType_8p6a24_k$('application', 'xml');
        this.Xml_Dtd_1 = ContentType().new_io_ktor_http_ContentType_8p6a24_k$('application', 'xml-dtd');
        this.Yaml_1 = ContentType().new_io_ktor_http_ContentType_8p6a24_k$('application', 'yaml');
        this.Zip_1 = ContentType().new_io_ktor_http_ContentType_8p6a24_k$('application', 'zip');
        this.GZip_1 = ContentType().new_io_ktor_http_ContentType_8p6a24_k$('application', 'gzip');
        this.FormUrlEncoded_1 = ContentType().new_io_ktor_http_ContentType_8p6a24_k$('application', 'x-www-form-urlencoded');
        this.Pdf_1 = ContentType().new_io_ktor_http_ContentType_8p6a24_k$('application', 'pdf');
        this.Xlsx_1 = ContentType().new_io_ktor_http_ContentType_8p6a24_k$('application', 'vnd.openxmlformats-officedocument.spreadsheetml.sheet');
        this.Docx_1 = ContentType().new_io_ktor_http_ContentType_8p6a24_k$('application', 'vnd.openxmlformats-officedocument.wordprocessingml.document');
        this.Pptx_1 = ContentType().new_io_ktor_http_ContentType_8p6a24_k$('application', 'vnd.openxmlformats-officedocument.presentationml.presentation');
        this.ProtoBuf_1 = ContentType().new_io_ktor_http_ContentType_8p6a24_k$('application', 'protobuf');
        this.Wasm_1 = ContentType().new_io_ktor_http_ContentType_8p6a24_k$('application', 'wasm');
        this.ProblemJson_1 = ContentType().new_io_ktor_http_ContentType_8p6a24_k$('application', 'problem+json');
        this.ProblemXml_1 = ContentType().new_io_ktor_http_ContentType_8p6a24_k$('application', 'problem+xml');
      }
    }
    initMetadataForObject($, 'Application');
    ApplicationClass = $;
  }
  return ApplicationClass;
}
var Application_instance;
function Application_getInstance() {
  if (Application_instance === VOID)
    new (Application())();
  return Application_instance;
}
var MultiPartClass;
function MultiPart() {
  if (MultiPartClass === VOID) {
    class $ {
      constructor() {
        MultiPart_instance = this;
        this.TYPE_1 = 'multipart';
        this.Any_1 = ContentType().new_io_ktor_http_ContentType_8p6a24_k$('multipart', '*');
        this.Mixed_1 = ContentType().new_io_ktor_http_ContentType_8p6a24_k$('multipart', 'mixed');
        this.Alternative_1 = ContentType().new_io_ktor_http_ContentType_8p6a24_k$('multipart', 'alternative');
        this.Related_1 = ContentType().new_io_ktor_http_ContentType_8p6a24_k$('multipart', 'related');
        this.FormData_1 = ContentType().new_io_ktor_http_ContentType_8p6a24_k$('multipart', 'form-data');
        this.Signed_1 = ContentType().new_io_ktor_http_ContentType_8p6a24_k$('multipart', 'signed');
        this.Encrypted_1 = ContentType().new_io_ktor_http_ContentType_8p6a24_k$('multipart', 'encrypted');
        this.ByteRanges_1 = ContentType().new_io_ktor_http_ContentType_8p6a24_k$('multipart', 'byteranges');
      }
      contains_vaykv6_k$(contentType) {
        return startsWith(contentType, 'multipart/', true);
      }
    }
    initMetadataForObject($, 'MultiPart');
    MultiPartClass = $;
  }
  return MultiPartClass;
}
var MultiPart_instance;
function MultiPart_getInstance() {
  if (MultiPart_instance === VOID)
    new (MultiPart())();
  return MultiPart_instance;
}
var TextClass;
function Text() {
  if (TextClass === VOID) {
    class $ {
      constructor() {
        Text_instance = this;
        this.TYPE_1 = 'text';
        this.Any_1 = ContentType().new_io_ktor_http_ContentType_8p6a24_k$('text', '*');
        this.Plain_1 = ContentType().new_io_ktor_http_ContentType_8p6a24_k$('text', 'plain');
        this.CSS_1 = ContentType().new_io_ktor_http_ContentType_8p6a24_k$('text', 'css');
        this.CSV_1 = ContentType().new_io_ktor_http_ContentType_8p6a24_k$('text', 'csv');
        this.Html_1 = ContentType().new_io_ktor_http_ContentType_8p6a24_k$('text', 'html');
        this.JavaScript_1 = ContentType().new_io_ktor_http_ContentType_8p6a24_k$('text', 'javascript');
        this.Markdown_1 = ContentType().new_io_ktor_http_ContentType_8p6a24_k$('text', 'markdown');
        this.VCard_1 = ContentType().new_io_ktor_http_ContentType_8p6a24_k$('text', 'vcard');
        this.Xml_1 = ContentType().new_io_ktor_http_ContentType_8p6a24_k$('text', 'xml');
        this.EventStream_1 = ContentType().new_io_ktor_http_ContentType_8p6a24_k$('text', 'event-stream');
      }
    }
    initMetadataForObject($, 'Text');
    TextClass = $;
  }
  return TextClass;
}
var Text_instance;
function Text_getInstance() {
  if (Text_instance === VOID)
    new (Text())();
  return Text_instance;
}
var ContentTypeClass;
function ContentType() {
  if (ContentTypeClass === VOID) {
    class $ extends HeaderValueWithParameters() {
      constructor(contentType, contentSubtype, existingContent, parameters) {
        return new.target.new_io_ktor_http_ContentType_y810h0_k$(contentType, contentSubtype, existingContent, parameters);
      }
      static new_io_ktor_http_ContentType_y810h0_k$(contentType, contentSubtype, existingContent, parameters) {
        Companion_getInstance();
        parameters = parameters === VOID ? emptyList() : parameters;
        var $this = this.new_io_ktor_http_HeaderValueWithParameters_3vfckb_k$(existingContent, parameters);
        $this.contentType_1 = contentType;
        $this.contentSubtype_1 = contentSubtype;
        return $this;
      }
      static new_io_ktor_http_ContentType_8p6a24_k$(contentType, contentSubtype, parameters) {
        Companion_getInstance();
        parameters = parameters === VOID ? emptyList() : parameters;
        return this.new_io_ktor_http_ContentType_y810h0_k$(contentType, contentSubtype, contentType + '/' + contentSubtype, parameters);
      }
      withParameter_j6bpqb_k$(name, value) {
        if (hasParameter(this, name, value))
          return this;
        return ContentType().new_io_ktor_http_ContentType_y810h0_k$(this.contentType_1, this.contentSubtype_1, this.content_1, plus(this.parameters_1, HeaderValueParam().new_io_ktor_http_HeaderValueParam_qys55l_k$(name, value)));
      }
      withoutParameters_wrqe36_k$() {
        return this.parameters_1.isEmpty_y1axqb_k$() ? this : ContentType().new_io_ktor_http_ContentType_8p6a24_k$(this.contentType_1, this.contentSubtype_1);
      }
      match_syvve3_k$(pattern) {
        if (!(pattern.contentType_1 === '*') && !equals(pattern.contentType_1, this.contentType_1, true)) {
          return false;
        }
        if (!(pattern.contentSubtype_1 === '*') && !equals(pattern.contentSubtype_1, this.contentSubtype_1, true)) {
          return false;
        }
        var _iterator__ex2g4s = pattern.parameters_1.iterator_jk1svi_k$();
        while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
          var _destruct__k2r9zo = _iterator__ex2g4s.next_20eer_k$();
          var patternName = _destruct__k2r9zo.component1_7eebsc_k$();
          var patternValue = _destruct__k2r9zo.component2_7eebsb_k$();
          var tmp;
          if (patternName === '*') {
            var tmp_0;
            if (patternValue === '*') {
              tmp_0 = true;
            } else {
              var tmp0 = this.parameters_1;
              var tmp$ret$0;
              $l$block_0: {
                // Inline function 'kotlin.collections.any' call
                var tmp_1;
                if (isInterface(tmp0, Collection())) {
                  tmp_1 = tmp0.isEmpty_y1axqb_k$();
                } else {
                  tmp_1 = false;
                }
                if (tmp_1) {
                  tmp$ret$0 = false;
                  break $l$block_0;
                }
                var _iterator__ex2g4s_0 = tmp0.iterator_jk1svi_k$();
                while (_iterator__ex2g4s_0.hasNext_bitz1p_k$()) {
                  var element = _iterator__ex2g4s_0.next_20eer_k$();
                  if (equals(element.value_1, patternValue, true)) {
                    tmp$ret$0 = true;
                    break $l$block_0;
                  }
                }
                tmp$ret$0 = false;
              }
              tmp_0 = tmp$ret$0;
            }
            tmp = tmp_0;
          } else {
            var value = this.parameter_w3eqbz_k$(patternName);
            tmp = patternValue === '*' ? !(value == null) : equals(value, patternValue, true);
          }
          var matches = tmp;
          if (!matches) {
            return false;
          }
        }
        return true;
      }
      equals(other) {
        var tmp;
        var tmp_0;
        var tmp_1;
        if (other instanceof ContentType()) {
          tmp_1 = equals(this.contentType_1, other.contentType_1, true);
        } else {
          tmp_1 = false;
        }
        if (tmp_1) {
          tmp_0 = equals(this.contentSubtype_1, other.contentSubtype_1, true);
        } else {
          tmp_0 = false;
        }
        if (tmp_0) {
          tmp = equals_0(this.parameters_1, other.parameters_1);
        } else {
          tmp = false;
        }
        return tmp;
      }
      hashCode() {
        // Inline function 'kotlin.text.lowercase' call
        // Inline function 'kotlin.js.asDynamic' call
        var tmp$ret$0 = this.contentType_1.toLowerCase();
        var result = getStringHashCode(tmp$ret$0);
        var tmp = result;
        var tmp_0 = imul(31, result);
        // Inline function 'kotlin.text.lowercase' call
        // Inline function 'kotlin.js.asDynamic' call
        var tmp$ret$2 = this.contentSubtype_1.toLowerCase();
        result = tmp + (tmp_0 + getStringHashCode(tmp$ret$2) | 0) | 0;
        result = result + imul(31, hashCode(this.parameters_1)) | 0;
        return result;
      }
    }
    initMetadataForClass($, 'ContentType');
    ContentTypeClass = $;
  }
  return ContentTypeClass;
}
function charset(_this__u8e3s4) {
  _init_properties_ContentTypes_kt__i9dj34();
  var tmp0_safe_receiver = _this__u8e3s4.parameter_w3eqbz_k$('charset');
  var tmp;
  if (tmp0_safe_receiver == null) {
    tmp = null;
  } else {
    // Inline function 'kotlin.let' call
    var tmp_0;
    try {
      tmp_0 = forName(Charsets_getInstance(), tmp0_safe_receiver);
    } catch ($p) {
      var tmp_1;
      if ($p instanceof IllegalArgumentException()) {
        var _unused_var__etf5q3 = $p;
        tmp_1 = null;
      } else {
        throw $p;
      }
      tmp_0 = tmp_1;
    }
    tmp = tmp_0;
  }
  return tmp;
}
var BadContentTypeFormatExceptionClass;
function BadContentTypeFormatException() {
  if (BadContentTypeFormatExceptionClass === VOID) {
    class $ extends Exception() {
      constructor(value) {
        return new.target.new_io_ktor_http_BadContentTypeFormatException_pqz1qq_k$(value);
      }
      static new_io_ktor_http_BadContentTypeFormatException_pqz1qq_k$(value) {
        var $this = this.new_kotlin_Exception_hsqbop_k$('Bad Content-Type format: ' + value);
        captureStack($this, $this.$throwableCtor_2);
        return $this;
      }
    }
    initMetadataForClass($, 'BadContentTypeFormatException');
    BadContentTypeFormatExceptionClass = $;
  }
  return BadContentTypeFormatExceptionClass;
}
function withCharset(_this__u8e3s4, charset) {
  _init_properties_ContentTypes_kt__i9dj34();
  return _this__u8e3s4.withParameter_j6bpqb_k$('charset', get_name(charset));
}
function withCharsetIfNeeded(_this__u8e3s4, charset) {
  _init_properties_ContentTypes_kt__i9dj34();
  var tmp;
  // Inline function 'kotlin.text.lowercase' call
  // Inline function 'kotlin.js.asDynamic' call
  if (!(_this__u8e3s4.contentType_1.toLowerCase() === 'text')) {
    tmp = _this__u8e3s4;
  } else {
    tmp = _this__u8e3s4.withParameter_j6bpqb_k$('charset', get_name(charset));
  }
  return tmp;
}
var properties_initialized_ContentTypes_kt_1k2nnm;
function _init_properties_ContentTypes_kt__i9dj34() {
  if (!properties_initialized_ContentTypes_kt_1k2nnm) {
    properties_initialized_ContentTypes_kt_1k2nnm = true;
    textSubTypes = setOf(['json', 'ld+json', 'xml', 'xhtml+xml', 'rss+xml', 'atom+xml', 'x-www-form-urlencoded', 'svg+xml']);
  }
}
//region block: exports
export {
  Application_getInstance as Application_getInstance3vhi2qmce4cj0,
  Companion_getInstance as Companion_getInstance2mdqh2piyf0f8,
  MultiPart_getInstance as MultiPart_getInstance5h1nld8q49pe,
  Text_getInstance as Text_getInstance2n0fbbag7eq4k,
  BadContentTypeFormatException as BadContentTypeFormatException2lqc4nmtnbgvk,
  ContentType as ContentType1svlpabm9v7iz,
  charset as charset1dribv3ku48b1,
  withCharsetIfNeeded as withCharsetIfNeeded3sz33ys0x9vfx,
  withCharset as withCharset27k3t3dvzhi4n,
};
//endregion

//# sourceMappingURL=ContentTypes.mjs.map
